import { Form } from 'antd';
import { useForm, useWatch } from 'antd/es/form/Form';
import { clsx } from 'clsx';
import { FC } from 'react';

import s from './AntForm.module.less';
import { AntFormItemProps } from './AntForm.types';

export const AntForm = Form;
export const AntFormList = Form.List;
export const useAntForm = useForm;
export const useAntFormWatch = useWatch;

export const AntFormItem: FC<AntFormItemProps> = (props) => {
  const { className, ...rest } = props;

  return <Form.Item className={clsx(s.antFormItem, className)} {...rest} />;
};

AntFormItem.displayName = 'AntFormItem';
